import * as types from '../constants/ActionTypes';
import { INITIAL_STATE } from '../constants/InitialState';

export function OptionsReducer(state = INITIAL_STATE, action) {
  const { type, payload } = action;
  switch (type) {
    case types.POPUP_CONTRIBUTOR:
      return {
        ...state,
        openPopupContributor: payload,
      };

    case types.POPUP_PAYMENT:
      return {
        ...state,
        openPopupPayment: payload,
      };

    case types.SELECT_PAYMENT_EVENT:
      return {
        ...state,
        selectPaymentEvent: payload,
      };

    case types.PREVIOUS_PATH:
      return {
        ...state,
        previousPath: payload,
      };

    case types.CONTROL_SIDEBAR:
      return {
        ...state,
        controlSidebar: payload,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/OptionsReducer.js